
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import ScenarioSelector from '../scenarios/ScenarioSelector';

interface ModelParametersCardProps {
  scenarioType: string;
  setScenarioType: (value: string) => void;
  stressLevel: number[];
  setStressLevel: (value: number[]) => void;
  includeContingent: boolean;
  setIncludeContingent: (value: boolean) => void;
  includeUndrawn: boolean;
  setIncludeUndrawn: (value: boolean) => void;
}

const ModelParametersCard: React.FC<ModelParametersCardProps> = ({
  scenarioType,
  setScenarioType,
  stressLevel,
  setStressLevel,
  includeContingent,
  setIncludeContingent,
  includeUndrawn,
  setIncludeUndrawn
}) => {
  const { toast } = useToast();

  const handleRunModel = () => {
    toast({
      title: "Model executed",
      description: `Cashflow model run with ${scenarioType} scenario at ${stressLevel}% stress level`,
    });
  };

  const handleSaveScenario = () => {
    toast({
      title: "Scenario saved",
      description: "Cashflow scenario saved for future reference",
    });
  };

  return (
    <Card className="lg:col-span-1">
      <CardHeader>
        <CardTitle className="flex items-center">
          <TrendingUp className="h-5 w-5 mr-2" />
          Cashflow Model Parameters
        </CardTitle>
        <CardDescription>
          Configure and run cashflow forecasting models
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <ScenarioSelector
          scenarioType={scenarioType}
          setScenarioType={setScenarioType}
          stressLevel={stressLevel}
          setStressLevel={setStressLevel}
          includeContingent={includeContingent}
          setIncludeContingent={setIncludeContingent}
          includeUndrawn={includeUndrawn}
          setIncludeUndrawn={setIncludeUndrawn}
        />

        <div className="pt-4">
          <Button className="w-full" onClick={handleRunModel}>
            Run Model
          </Button>
        </div>
      </CardContent>
      <CardFooter className="flex justify-between border-t pt-4">
        <Button variant="outline" onClick={handleSaveScenario}>
          Save Scenario
        </Button>
        <Button variant="outline">
          Load Scenario
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ModelParametersCard;
